import _ from "../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import y from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import j from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import V from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import R from "../../@babel/runtime/helpers/esm/typeof.mjs";
import x from "../../@babel/runtime/helpers/esm/createClass.mjs";
import K from "../../@babel/runtime/helpers/esm/classCallCheck.mjs";
import a from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import E, { merge as U } from "../../rc-util/es/utils/set.mjs";
import M from "../../rc-util/es/warning.mjs";
import * as $ from "react";
import { HOOK_MARK as z } from "./FieldContext.mjs";
import { allPromiseFinish as B } from "./utils/asyncUtil.mjs";
import { defaultValidateMessages as J } from "./utils/messages.mjs";
import b from "./utils/NameMap.mjs";
import { getNamePath as g, cloneByNamePathList as C, containsNamePath as O, matchNamePath as Q } from "./utils/valueUtil.mjs";
import W from "../../rc-util/es/utils/get.mjs";
var q = ["name"], G = /* @__PURE__ */ x(function N(P) {
  var e = this;
  K(this, N), a(this, "formHooked", !1), a(this, "forceRootUpdate", void 0), a(this, "subscribable", !0), a(this, "store", {}), a(this, "fieldEntities", []), a(this, "initialValues", {}), a(this, "callbacks", {}), a(this, "validateMessages", null), a(this, "preserve", null), a(this, "lastValidatePromise", null), a(this, "getForm", function() {
    return {
      getFieldValue: e.getFieldValue,
      getFieldsValue: e.getFieldsValue,
      getFieldError: e.getFieldError,
      getFieldWarning: e.getFieldWarning,
      getFieldsError: e.getFieldsError,
      isFieldsTouched: e.isFieldsTouched,
      isFieldTouched: e.isFieldTouched,
      isFieldValidating: e.isFieldValidating,
      isFieldsValidating: e.isFieldsValidating,
      resetFields: e.resetFields,
      setFields: e.setFields,
      setFieldValue: e.setFieldValue,
      setFieldsValue: e.setFieldsValue,
      validateFields: e.validateFields,
      submit: e.submit,
      _init: !0,
      getInternalHooks: e.getInternalHooks
    };
  }), a(this, "getInternalHooks", function(t) {
    return t === z ? (e.formHooked = !0, {
      dispatch: e.dispatch,
      initEntityValue: e.initEntityValue,
      registerField: e.registerField,
      useSubscribe: e.useSubscribe,
      setInitialValues: e.setInitialValues,
      destroyForm: e.destroyForm,
      setCallbacks: e.setCallbacks,
      setValidateMessages: e.setValidateMessages,
      getFields: e.getFields,
      setPreserve: e.setPreserve,
      getInitialValue: e.getInitialValue,
      registerWatch: e.registerWatch
    }) : (M(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), a(this, "useSubscribe", function(t) {
    e.subscribable = t;
  }), a(this, "prevWithoutPreserves", null), a(this, "setInitialValues", function(t, i) {
    if (e.initialValues = t || {}, i) {
      var r, n = U(t, e.store);
      (r = e.prevWithoutPreserves) === null || r === void 0 || r.map(function(l) {
        var s = l.key;
        n = E(n, s, W(t, s));
      }), e.prevWithoutPreserves = null, e.updateStore(n);
    }
  }), a(this, "destroyForm", function(t) {
    if (t)
      e.updateStore({});
    else {
      var i = new b();
      e.getFieldEntities(!0).forEach(function(r) {
        e.isMergedPreserve(r.isPreserve()) || i.set(r.getNamePath(), !0);
      }), e.prevWithoutPreserves = i;
    }
  }), a(this, "getInitialValue", function(t) {
    var i = W(e.initialValues, t);
    return t.length ? U(i) : i;
  }), a(this, "setCallbacks", function(t) {
    e.callbacks = t;
  }), a(this, "setValidateMessages", function(t) {
    e.validateMessages = t;
  }), a(this, "setPreserve", function(t) {
    e.preserve = t;
  }), a(this, "watchList", []), a(this, "registerWatch", function(t) {
    return e.watchList.push(t), function() {
      e.watchList = e.watchList.filter(function(i) {
        return i !== t;
      });
    };
  }), a(this, "notifyWatch", function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (e.watchList.length) {
      var i = e.getFieldsValue(), r = e.getFieldsValue(!0);
      e.watchList.forEach(function(n) {
        n(i, r, t);
      });
    }
  }), a(this, "timeoutId", null), a(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !e.timeoutId && typeof window < "u" && (e.timeoutId = setTimeout(function() {
      e.timeoutId = null, e.formHooked || M(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), a(this, "updateStore", function(t) {
    e.store = t;
  }), a(this, "getFieldEntities", function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return t ? e.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : e.fieldEntities;
  }), a(this, "getFieldsMap", function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new b();
    return e.getFieldEntities(t).forEach(function(r) {
      var n = r.getNamePath();
      i.set(n, r);
    }), i;
  }), a(this, "getFieldEntitiesForNamePathList", function(t) {
    if (!t)
      return e.getFieldEntities(!0);
    var i = e.getFieldsMap(!0);
    return t.map(function(r) {
      var n = g(r);
      return i.get(n) || {
        INVALIDATE_NAME_PATH: g(r)
      };
    });
  }), a(this, "getFieldsValue", function(t, i) {
    e.warningUnhooked();
    var r, n, l;
    if (t === !0 || Array.isArray(t) ? (r = t, n = i) : t && R(t) === "object" && (l = t.strict, n = t.filter), r === !0 && !n)
      return e.store;
    var s = e.getFieldEntitiesForNamePathList(Array.isArray(r) ? r : null), o = [];
    return s.forEach(function(d) {
      var u, f, v = "INVALIDATE_NAME_PATH" in d ? d.INVALIDATE_NAME_PATH : d.getNamePath();
      if (l) {
        var p, c;
        if ((p = (c = d).isList) !== null && p !== void 0 && p.call(c))
          return;
      } else if (!r && (u = (f = d).isListField) !== null && u !== void 0 && u.call(f))
        return;
      if (!n)
        o.push(v);
      else {
        var F = "getMeta" in d ? d.getMeta() : null;
        n(F) && o.push(v);
      }
    }), C(e.store, o.map(g));
  }), a(this, "getFieldValue", function(t) {
    e.warningUnhooked();
    var i = g(t);
    return W(e.store, i);
  }), a(this, "getFieldsError", function(t) {
    e.warningUnhooked();
    var i = e.getFieldEntitiesForNamePathList(t);
    return i.map(function(r, n) {
      return r && !("INVALIDATE_NAME_PATH" in r) ? {
        name: r.getNamePath(),
        errors: r.getErrors(),
        warnings: r.getWarnings()
      } : {
        name: g(t[n]),
        errors: [],
        warnings: []
      };
    });
  }), a(this, "getFieldError", function(t) {
    e.warningUnhooked();
    var i = g(t), r = e.getFieldsError([i])[0];
    return r.errors;
  }), a(this, "getFieldWarning", function(t) {
    e.warningUnhooked();
    var i = g(t), r = e.getFieldsError([i])[0];
    return r.warnings;
  }), a(this, "isFieldsTouched", function() {
    e.warningUnhooked();
    for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++)
      i[r] = arguments[r];
    var n = i[0], l = i[1], s, o = !1;
    i.length === 0 ? s = null : i.length === 1 ? Array.isArray(n) ? (s = n.map(g), o = !1) : (s = null, o = n) : (s = n.map(g), o = l);
    var d = e.getFieldEntities(!0), u = function(c) {
      return c.isFieldTouched();
    };
    if (!s)
      return o ? d.every(function(c) {
        return u(c) || c.isList();
      }) : d.some(u);
    var f = new b();
    s.forEach(function(c) {
      f.set(c, []);
    }), d.forEach(function(c) {
      var F = c.getNamePath();
      s.forEach(function(I) {
        I.every(function(h, m) {
          return F[m] === h;
        }) && f.update(I, function(h) {
          return [].concat(V(h), [c]);
        });
      });
    });
    var v = function(c) {
      return c.some(u);
    }, p = f.map(function(c) {
      var F = c.value;
      return F;
    });
    return o ? p.every(v) : p.some(v);
  }), a(this, "isFieldTouched", function(t) {
    return e.warningUnhooked(), e.isFieldsTouched([t]);
  }), a(this, "isFieldsValidating", function(t) {
    e.warningUnhooked();
    var i = e.getFieldEntities();
    if (!t)
      return i.some(function(n) {
        return n.isFieldValidating();
      });
    var r = t.map(g);
    return i.some(function(n) {
      var l = n.getNamePath();
      return O(r, l) && n.isFieldValidating();
    });
  }), a(this, "isFieldValidating", function(t) {
    return e.warningUnhooked(), e.isFieldsValidating([t]);
  }), a(this, "resetWithFieldInitialValue", function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new b(), r = e.getFieldEntities(!0);
    r.forEach(function(s) {
      var o = s.props.initialValue, d = s.getNamePath();
      if (o !== void 0) {
        var u = i.get(d) || /* @__PURE__ */ new Set();
        u.add({
          entity: s,
          value: o
        }), i.set(d, u);
      }
    });
    var n = function(s) {
      s.forEach(function(o) {
        var d = o.props.initialValue;
        if (d !== void 0) {
          var u = o.getNamePath(), f = e.getInitialValue(u);
          if (f !== void 0)
            M(!1, "Form already set 'initialValues' with path '".concat(u.join("."), "'. Field can not overwrite it."));
          else {
            var v = i.get(u);
            if (v && v.size > 1)
              M(!1, "Multiple Field with path '".concat(u.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (v) {
              var p = e.getFieldValue(u), c = o.isListField();
              !c && (!t.skipExist || p === void 0) && e.updateStore(E(e.store, u, V(v)[0].value));
            }
          }
        }
      });
    }, l;
    t.entities ? l = t.entities : t.namePathList ? (l = [], t.namePathList.forEach(function(s) {
      var o = i.get(s);
      if (o) {
        var d;
        (d = l).push.apply(d, V(V(o).map(function(u) {
          return u.entity;
        })));
      }
    })) : l = r, n(l);
  }), a(this, "resetFields", function(t) {
    e.warningUnhooked();
    var i = e.store;
    if (!t) {
      e.updateStore(U(e.initialValues)), e.resetWithFieldInitialValue(), e.notifyObservers(i, null, {
        type: "reset"
      }), e.notifyWatch();
      return;
    }
    var r = t.map(g);
    r.forEach(function(n) {
      var l = e.getInitialValue(n);
      e.updateStore(E(e.store, n, l));
    }), e.resetWithFieldInitialValue({
      namePathList: r
    }), e.notifyObservers(i, r, {
      type: "reset"
    }), e.notifyWatch(r);
  }), a(this, "setFields", function(t) {
    e.warningUnhooked();
    var i = e.store, r = [];
    t.forEach(function(n) {
      var l = n.name, s = j(n, q), o = g(l);
      r.push(o), "value" in s && e.updateStore(E(e.store, o, s.value)), e.notifyObservers(i, [o], {
        type: "setField",
        data: n
      });
    }), e.notifyWatch(r);
  }), a(this, "getFields", function() {
    var t = e.getFieldEntities(!0), i = t.map(function(r) {
      var n = r.getNamePath(), l = r.getMeta(), s = y(y({}, l), {}, {
        name: n,
        value: e.getFieldValue(n)
      });
      return Object.defineProperty(s, "originRCField", {
        value: !0
      }), s;
    });
    return i;
  }), a(this, "initEntityValue", function(t) {
    var i = t.props.initialValue;
    if (i !== void 0) {
      var r = t.getNamePath(), n = W(e.store, r);
      n === void 0 && e.updateStore(E(e.store, r, i));
    }
  }), a(this, "isMergedPreserve", function(t) {
    var i = t !== void 0 ? t : e.preserve;
    return i ?? !0;
  }), a(this, "registerField", function(t) {
    e.fieldEntities.push(t);
    var i = t.getNamePath();
    if (e.notifyWatch([i]), t.props.initialValue !== void 0) {
      var r = e.store;
      e.resetWithFieldInitialValue({
        entities: [t],
        skipExist: !0
      }), e.notifyObservers(r, [t.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(n, l) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (e.fieldEntities = e.fieldEntities.filter(function(u) {
        return u !== t;
      }), !e.isMergedPreserve(l) && (!n || s.length > 1)) {
        var o = n ? void 0 : e.getInitialValue(i);
        if (i.length && e.getFieldValue(i) !== o && e.fieldEntities.every(function(u) {
          return (
            // Only reset when no namePath exist
            !Q(u.getNamePath(), i)
          );
        })) {
          var d = e.store;
          e.updateStore(E(d, i, o, !0)), e.notifyObservers(d, [i], {
            type: "remove"
          }), e.triggerDependenciesUpdate(d, i);
        }
      }
      e.notifyWatch([i]);
    };
  }), a(this, "dispatch", function(t) {
    switch (t.type) {
      case "updateValue": {
        var i = t.namePath, r = t.value;
        e.updateValue(i, r);
        break;
      }
      case "validateField": {
        var n = t.namePath, l = t.triggerName;
        e.validateFields([n], {
          triggerName: l
        });
        break;
      }
    }
  }), a(this, "notifyObservers", function(t, i, r) {
    if (e.subscribable) {
      var n = y(y({}, r), {}, {
        store: e.getFieldsValue(!0)
      });
      e.getFieldEntities().forEach(function(l) {
        var s = l.onStoreChange;
        s(t, i, n);
      });
    } else
      e.forceRootUpdate();
  }), a(this, "triggerDependenciesUpdate", function(t, i) {
    var r = e.getDependencyChildrenFields(i);
    return r.length && e.validateFields(r), e.notifyObservers(t, r, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(V(r))
    }), r;
  }), a(this, "updateValue", function(t, i) {
    var r = g(t), n = e.store;
    e.updateStore(E(e.store, r, i)), e.notifyObservers(n, [r], {
      type: "valueUpdate",
      source: "internal"
    }), e.notifyWatch([r]);
    var l = e.triggerDependenciesUpdate(n, r), s = e.callbacks.onValuesChange;
    if (s) {
      var o = C(e.store, [r]);
      s(o, e.getFieldsValue());
    }
    e.triggerOnFieldsChange([r].concat(V(l)));
  }), a(this, "setFieldsValue", function(t) {
    e.warningUnhooked();
    var i = e.store;
    if (t) {
      var r = U(e.store, t);
      e.updateStore(r);
    }
    e.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), e.notifyWatch();
  }), a(this, "setFieldValue", function(t, i) {
    e.setFields([{
      name: t,
      value: i
    }]);
  }), a(this, "getDependencyChildrenFields", function(t) {
    var i = /* @__PURE__ */ new Set(), r = [], n = new b();
    e.getFieldEntities().forEach(function(s) {
      var o = s.props.dependencies;
      (o || []).forEach(function(d) {
        var u = g(d);
        n.update(u, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(s), f;
        });
      });
    });
    var l = function s(o) {
      var d = n.get(o) || /* @__PURE__ */ new Set();
      d.forEach(function(u) {
        if (!i.has(u)) {
          i.add(u);
          var f = u.getNamePath();
          u.isFieldDirty() && f.length && (r.push(f), s(f));
        }
      });
    };
    return l(t), r;
  }), a(this, "triggerOnFieldsChange", function(t, i) {
    var r = e.callbacks.onFieldsChange;
    if (r) {
      var n = e.getFields();
      if (i) {
        var l = new b();
        i.forEach(function(o) {
          var d = o.name, u = o.errors;
          l.set(d, u);
        }), n.forEach(function(o) {
          o.errors = l.get(o.name) || o.errors;
        });
      }
      var s = n.filter(function(o) {
        var d = o.name;
        return O(t, d);
      });
      s.length && r(s, n);
    }
  }), a(this, "validateFields", function(t, i) {
    e.warningUnhooked();
    var r, n;
    Array.isArray(t) || typeof t == "string" || typeof i == "string" ? (r = t, n = i) : n = t;
    var l = !!r, s = l ? r.map(g) : [], o = [], d = String(Date.now()), u = /* @__PURE__ */ new Set(), f = n || {}, v = f.recursive, p = f.dirty;
    e.getFieldEntities(!0).forEach(function(h) {
      if (l || s.push(h.getNamePath()), !(!h.props.rules || !h.props.rules.length) && !(p && !h.isFieldDirty())) {
        var m = h.getNamePath();
        if (u.add(m.join(d)), !l || O(s, m, v)) {
          var w = h.validateRules(y({
            validateMessages: y(y({}, J), e.validateMessages)
          }, n));
          o.push(w.then(function() {
            return {
              name: m,
              errors: [],
              warnings: []
            };
          }).catch(function(A) {
            var L, k = [], S = [];
            return (L = A.forEach) === null || L === void 0 || L.call(A, function(T) {
              var H = T.rule.warningOnly, D = T.errors;
              H ? S.push.apply(S, V(D)) : k.push.apply(k, V(D));
            }), k.length ? Promise.reject({
              name: m,
              errors: k,
              warnings: S
            }) : {
              name: m,
              errors: k,
              warnings: S
            };
          }));
        }
      }
    });
    var c = B(o);
    e.lastValidatePromise = c, c.catch(function(h) {
      return h;
    }).then(function(h) {
      var m = h.map(function(w) {
        var A = w.name;
        return A;
      });
      e.notifyObservers(e.store, m, {
        type: "validateFinish"
      }), e.triggerOnFieldsChange(m, h);
    });
    var F = c.then(function() {
      return e.lastValidatePromise === c ? Promise.resolve(e.getFieldsValue(s)) : Promise.reject([]);
    }).catch(function(h) {
      var m = h.filter(function(w) {
        return w && w.errors.length;
      });
      return Promise.reject({
        values: e.getFieldsValue(s),
        errorFields: m,
        outOfDate: e.lastValidatePromise !== c
      });
    });
    F.catch(function(h) {
      return h;
    });
    var I = s.filter(function(h) {
      return u.has(h.join(d));
    });
    return e.triggerOnFieldsChange(I), F;
  }), a(this, "submit", function() {
    e.warningUnhooked(), e.validateFields().then(function(t) {
      var i = e.callbacks.onFinish;
      if (i)
        try {
          i(t);
        } catch (r) {
          console.error(r);
        }
    }).catch(function(t) {
      var i = e.callbacks.onFinishFailed;
      i && i(t);
    });
  }), this.forceRootUpdate = P;
});
function fe(N) {
  var P = $.useRef(), e = $.useState({}), t = _(e, 2), i = t[1];
  if (!P.current)
    if (N)
      P.current = N;
    else {
      var r = function() {
        i({});
      }, n = new G(r);
      P.current = n.getForm();
    }
  return [P.current];
}
export {
  G as FormStore,
  fe as default
};
//# sourceMappingURL=useForm.mjs.map
